export default __webpack_public_path__ + "static/media/chicken01.6df38275.png";